import { render, staticRenderFns } from "./RenounceSaving.vue?vue&type=template&id=33b4916d&scoped=true&"
import script from "./RenounceSaving.vue?vue&type=script&lang=js&"
export * from "./RenounceSaving.vue?vue&type=script&lang=js&"
import style0 from "./RenounceSaving.vue?vue&type=style&index=0&id=33b4916d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b4916d",
  null
  
)

export default component.exports